// extracted by mini-css-extract-plugin
module.exports = {"container":"_3_Wx275KfyMZ1XamtOgDAT"};